



























import Selector from '@/utility/Selector';
import { SelectorMap } from '@/utility/TemplateOptions';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class NestedOption extends Vue {
    @Prop()
    public label: string;

    @Prop()
    public nestedSelector: Selector;

    @Prop()
    public selectors: SelectorMap;

    private chosenNestedSelectors(sel: Selector, isArray: boolean) {
        const values = sel.value || [];
        const prefixedSelectorValues = values.map((x: any) => `${sel.nestedControlPrefix} ${x}`);
        return Object.fromEntries(
            Object.entries(this.selectors).filter(
                (e, i, a) => {
                    let arrayCheck = (Array.isArray(e[1].options) === isArray)
                    return prefixedSelectorValues.includes(e[0]) && arrayCheck;
                }
            ).map(([k,v]) => [k.substring(sel.nestedControlPrefix!.length),v]));
    }
}
